import { render } from "./AccessoryItem.vue?vue&type=template&id=219c1eba&scoped=true"
import script from "./AccessoryItem.vue?vue&type=script&lang=js"
export * from "./AccessoryItem.vue?vue&type=script&lang=js"

import "./AccessoryItem.vue?vue&type=style&index=0&id=219c1eba&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219c1eba"]])

export default __exports__